import { CreateUserFormData, EditUserFormData, Role } from '../types/user';
import { User } from '../types';
import { message } from 'antd';
import api from '../api/axios';
import { decryptData } from '../utils/decrypt';

export const getAllUsers = async (): Promise<User[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/users`);

       const decrypted = decryptData(response.data, response.data.iv);
     
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};
export const createUser = async (data: CreateUserFormData) => {
  try {
    const response = await api.post(`${import.meta.env.VITE_API_BASE_URL}/users`, data);
    if (response.status !== 200 && response.status !== 201) {
      message.error('Error creating user');
      throw new Error('Error creating user');
    }
     const decrypted = decryptData(response.data, response.data.iv);
     
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};
export const updateUser = async (data: EditUserFormData, id: string) => {
  try {
    const response = await api.post(`${import.meta.env.VITE_API_BASE_URL}/users/${id}`, data);
    if (response.status !== 200 && response.status !== 201) {
      message.error('Error editing user');
      throw new Error('Error editing user');
    }
      const decrypted = decryptData(response.data, response.data.iv);
     
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const deleteUser = async (id: string) => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/users/delete/${id}`);
    if (response.status !== 200 && response.status !== 204) {
      message.error('Error deleting user');
      throw new Error('Error deleting user');
    }
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const getAllRoles = async (): Promise<Role[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/roles`);
    if (response.status !== 200) throw new Error('Error fetching roles');
     const decrypted = decryptData(response.data, response.data.iv);
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const GetAllDeleteUsers = async (): Promise<User[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/users/all-deleted-users`);
    if (response.status !== 200) throw new Error('Error fetching deleted users');
     const decrypted = decryptData(response.data, response.data.iv);
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error fetching deleted users:', error);
    throw error;
  }
};

export const restoreUser = async (id: string) => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/users/restore/${id}`);
    if (response.status !== 200 && response.status !== 201) {
      message.error('Error restoring user');
      throw new Error('Error restoring user');
    }
       const decrypted = decryptData(response.data, response.data.iv);
     return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error restoring user:', error);
    throw error;
  }
};
